import RecipeLogStep, { type RecipeLogStepProps } from '../RecipeLogStep'

const CookedStep = (props: Omit<RecipeLogStepProps, 'title' | 'description' | 'hint' | 'quantityKey' | 'logType' | 'showReason'>) => (
  <RecipeLogStep
    {...props}
    title="What was cooked today?"
    description="Log the total quantity prepared today — including anything not yet served."
    hint="Use the unit shown next to each recipe. Estimate if unsure."
    quantityKey="cooked_quantity"
    logType="cooked"
  />
)

export default CookedStep
